<template>
    <div class="d-flex justify-end">
        <SrButton
            v-if="showCloseButton"
            ref="close"
            class="close"
            color="blue"
            outlined
            :loading="isCloseLoading"
            :disabled="isCloseDisabled"
            @click="$emit('close-modal-clicked')"
        >
            {{ closeText }}
        </SrButton>
        <SrButton v-if="showBackButton && canBack" ref="back" type="delete" :disabled="isLoading" @click="$emit('back-clicked')">
            {{ backText }}
        </SrButton>
        <SrButton
            v-if="showContinueButton"
            ref="continue"
            class="ml-2"
            type="secondary"
            :loading="isLoading"
            :disabled="isContinueDisabled"
            @click="$emit('continue-clicked')"
        >
            {{ continueText }}
        </SrButton>
    </div>
</template>

<script>
import SrButton from '../../components/SrButton/SrButton';

export default {
    name: 'SrModalPageFormFooter',
    components: { SrButton },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        isCloseLoading: {
            type: Boolean,
            default: false,
        },
        canContinue: {
            type: Boolean,
            default: false,
        },
        canBack: {
            type: Boolean,
            default: false,
        },
        canClose: {
            type: Boolean,
            default: false,
        },
        continueText: {
            type: String,
            default: '',
        },
        closeText: {
            type: String,
            default: '',
        },
        showCloseButton: {
            type: Boolean,
            default: true,
        },
        backText: {
            type: String,
            default: '',
        },
        showBackButton: {
            type: Boolean,
            default: true,
        },
        showContinueButton: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        isLoading() {
            return this.loading;
        },
        isContinueDisabled() {
            return !this.canContinue;
        },
        isCloseDisabled() {
            return !this.canClose;
        },
    },
};
</script>
